import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { EModuleType } from "../../../../Model/EModuleType";
import { getModulesByType } from "../../../../redux/reducers/ModuleReducer";
import { getModules } from "../../../../redux/reducers/ModuleReducer";
import { getStorageConfig } from "../../../../redux/reducers/StorageConfigReducer";
import { useTypedSelector } from "../../../../redux/reducers/RootReducer";
import { ENotificationType } from "../../../../Model/ENotificationType";
import { ECarrier } from "../../../../Model/ECarrier";
import CommonDropDown from "../../../Common/DropDown/CommonDropDown";
import MtiButton from "../../../Buttons/MtiButton";
import "./SlotCorrection.css";
import "../HotelCalibration/HotelOffsetView.css";
import AllSlotContent from "./AllSlotContent";
import AllHotelContent from "./AllHotelContent";
import CorrectionResultContent from "./CorrectionResultContent";
import {
  SlotAddress,
  SlotCorrectionResult,
} from "../../../../Model/SlotCorrection";
import CalibrationApi from "../../../../api/CalibrationApi";
import {
  ESuiteModeState,
  ESuiteMode,
  EPsrState,
} from "../../../../Model/ModuleState";
import { getModuleState } from "../../../../redux/reducers/ModuleStateReducer";
import SlotCorrectionProgressModal from "./SlotCorrectionModal/SlotCorrectionProgressModal";
import SlotCorrectionSuccessModal from "./SlotCorrectionModal/SlotCorrectionSuccessModal";
import SlotCorrectionPreconditionFailModal from "./SlotCorrectionModal/SlotCorrectionPreconditionFailModal";
import { sendNotification } from "../../../../redux/actions/NotificationAction";
import FailedSlotContent from "./FailedSlotContent";
import { getPlateAddressesOnModule } from "../../../../redux/reducers/PlateAddressReducer";
import { PlateAddress } from "../../../../Model/PlateAddress";

export const HOTEL_ACCORDION_STATE = "HOTEL_ACCORDION_STATE";

type CarrierDisplayValue = {
  display: string;
  value: ECarrier;
  disabled: boolean;
};

function getAccordionState(key: string): boolean[] {
  const value = localStorage.getItem(key);
  if (value != null) {
    return JSON.parse(value);
  } else {
    return [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ];
  }
}

function getExpandAllAccordionState(key: string): boolean {
  const value = localStorage.getItem(key);
  if (value != null) {
    const accordionState: boolean[] = JSON.parse(value);
    return accordionState.some((val) => val === false);
  } else {
    return true;
  }
}

type PopupModalState = "IDLE" | "INPROGRESS" | "SUCCESS" | "FAIL";

const getInitialModalState = (
  suiteMode: ESuiteMode,
  slotCorrectionState: ESuiteModeState
): PopupModalState => {
  if (
    suiteMode === ESuiteMode.SlotCorrection &&
    (slotCorrectionState === ESuiteModeState.Started ||
      slotCorrectionState === ESuiteModeState.Stopping)
  ) {
    return "INPROGRESS";
  } else {
    return "IDLE";
  }
};

const getUserIntentionallyStopLocalStorage = (
  slotCorrectionState: ESuiteModeState
) => {
  if (slotCorrectionState === ESuiteModeState.Stopping) {
    const resultString = localStorage.getItem("USER_STOP_SLOT_CORRECTION");
    return resultString === "true" ? true : false;
  }

  return false;
};

const setUserIntentionallyStopLocalStorage = (value: boolean) => {
  localStorage.setItem("USER_STOP_SLOT_CORRECTION", value.toString());
};

type Props = {
  setOnApply: (onApply: { execute: () => void; disabled: boolean }) => void;
  setOnCancel: (onCancel: { execute: () => void; disabled: boolean }) => void;
  isSlotCorrectionUpdated: boolean;
  setIsSlotCorrectionUpdated: (isSlotCorrectionUpdated: boolean) => void;
};

export default function SlotCorrectionContent({
  setOnApply,
  setOnCancel,
  isSlotCorrectionUpdated,
  setIsSlotCorrectionUpdated,
}: Props) {
  /*--------SLOT STATE SELECTION--------*/
  const [selectedSlot, setSelectedSlot] = useState(1);
  const slotSelection = [
    {
      display: "Failed Slot",
      disabled: false,
      value: 1,
    },
    {
      display: "All Slot",
      disabled: false,
      value: 2,
    },
    {
      display: "All Hotel",
      disabled: false,
      value: 3,
    },
  ] as CarrierDisplayValue[];

  /*--------HOTEL ACCORDION--------*/
  const [canExpandAll, setCanExpandAll] = useState(
    getExpandAllAccordionState(HOTEL_ACCORDION_STATE)
  );
  const [accordionState, setAccordionState] = useState(
    getAccordionState(HOTEL_ACCORDION_STATE)
  );

  useEffect(() => {
    localStorage.setItem(HOTEL_ACCORDION_STATE, JSON.stringify(accordionState));
  }, [accordionState]);

  const onExpandAllToggleClicked = () => {
    if (!canExpandAll) {
      setAccordionState([
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ]);
      setCanExpandAll(true);
    } else {
      setAccordionState([
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
      ]);
      setCanExpandAll(false);
    }
  };
  const storageModule = useTypedSelector(
    (state) => getModulesByType(state)[EModuleType.CHAMBER][0]
  );
  const plateAddresses = useTypedSelector((state) =>
    getPlateAddressesOnModule(state, storageModule.identifier)
  );
  const [selectAllChecked, setSelectAllChecked] = useState<string[]>([]);

  /*--------SLOT SELECTION--------*/
  const [slotAddress, setSlotAddress] = useState([] as SlotAddress[]);

  /*--------RUN CORRECTION--------*/
  const psrModules = useTypedSelector((state) =>
    getModules(state, EModuleType.PSR)
  );
  const psrModule = psrModules[0];
  const psrIdentifier = psrModule.identifier;
  const runSlotCorrection = () => {
    const filteredPlateAddresses = slotAddress
      .map((sa) => {
        const filteredPlateAddress = plateAddresses.find(
          (pa) =>
            pa.moduleIdentifier === sa.moduleIdentifier &&
            pa.hotelNo === sa.hotelNumber &&
            pa.slotNo === sa.slotNumber
        );
        return filteredPlateAddress as PlateAddress;
      })
      .filter((pa) => pa !== undefined);

    CalibrationApi.runSlotCorrection(
      psrIdentifier,
      filteredPlateAddresses
    ).then((res) => {
      console.log(res);
    });
  };

  const suiteState = useTypedSelector(
    (state) => state.moduleStateStore.moduleStateById["Suite"]?.suite
  );
  const suiteMode = suiteState?.suiteMode ?? ESuiteMode.SlotCorrection;
  const slotCorrectionState = suiteState?.slotCorrection;
  const psrState = useTypedSelector(
    (state) => getModuleState(state, psrIdentifier).psr
  );

  const [popupModalState, setPopupModalState] = useState(
    getInitialModalState(
      suiteMode,
      slotCorrectionState?.modeState ?? ESuiteModeState.Starting
    )
  );

  const needShowModalAfterProgress = useRef(popupModalState === "INPROGRESS");
  const [disableDoneAnimation, setDisableDoneAnimation] = useState(false);
  const onHideDone = useCallback(() => {
    setPopupModalState("IDLE");
    needShowModalAfterProgress.current = false;
  }, []);

  // popup state changes logic
  useEffect(() => {
    const checkSlotCorrectionResult = () => {
      if (slotCorrectionState?.isUpdatedSlotCorrectionExist) {
        setNeedFetchSlotCorrectionResult(true);
        setIsSlotCorrectionUpdated(true);
      }
    };

    if (suiteMode === ESuiteMode.SlotCorrection) {
      setPopupModalState("INPROGRESS");
      needShowModalAfterProgress.current = true;
      setDisableDoneAnimation(false);
    } else if (suiteMode === ESuiteMode.ArmCrashed) {
      setPopupModalState("FAIL");
      checkSlotCorrectionResult();
      needShowModalAfterProgress.current = false;
      setDisableDoneAnimation(true);
    } else if (needShowModalAfterProgress.current) {
      checkSlotCorrectionResult();
      if (userIntentionallyStop) {
        setPopupModalState("IDLE");
        needShowModalAfterProgress.current = false;
      } else {
        if (slotCorrectionState?.isSlotCorrectionSuccess) {
          setSlotAddress([]);
          setSelectAllChecked([]);
          setPopupModalState("SUCCESS");
        } else {
          setPopupModalState("FAIL");
          setDisableDoneAnimation(true);
        }
      }
    }
  }, [
    suiteMode,
    slotCorrectionState,
    slotCorrectionState?.isUpdatedSlotCorrectionExist,
  ]);

  /*--------STOP CORRECTION--------*/
  const [userIntentionallyStop, setUserIntentionallyStop] = useState(
    getUserIntentionallyStopLocalStorage(
      slotCorrectionState?.modeState ?? ESuiteModeState.Starting
    )
  );

  const stopSlotCorrection = () => {
    setUserIntentionallyStop(true);
    setUserIntentionallyStopLocalStorage(true);
    CalibrationApi.stopSlotCorrection(psrIdentifier);
  };

  /*--------APPLY AND CANCEL--------*/
  const dispatch = useDispatch();
  useEffect(() => {
    setOnApply({
      execute: onApply,
      disabled: !isSlotCorrectionUpdated,
    });
    setOnCancel({
      execute: onCancel,
      disabled: !isSlotCorrectionUpdated,
    });
  }, [isSlotCorrectionUpdated]);

  const onApply = () => {
    CalibrationApi.saveSlotCorrection(
      psrIdentifier,
      updatedSlotCorrectionResults.length === 0
        ? []
        : updatedSlotCorrectionResults
    ).then(() => {
      setNeedFetchSlotCorrectionResult(true);
      setIsSlotCorrectionUpdated(false);
      setUpdatedSlotCorrectionResults([]);
      dispatch(
        sendNotification(
          ENotificationType.Success,
          "The changes has been saved successfully."
        )
      );
    });
  };

  useEffect(() => {
    setIsSlotCorrectionUpdated(
      slotCorrectionState?.isUpdatedSlotCorrectionExist ?? false
    );
    setNeedFetchSlotCorrectionResult(true);
  }, [slotCorrectionState?.isUpdatedSlotCorrectionExist]);

  const onCancel = () => {
    CalibrationApi.discardSlotCorrection(psrIdentifier);
    setNeedFetchSlotCorrectionResult(true);
    setIsSlotCorrectionUpdated(false);
    setUpdatedSlotCorrectionResults([]);
  };

  /*--------CORRECTION RESULT--------*/
  const [needFetchSlotCorrectionResult, setNeedFetchSlotCorrectionResult] =
    useState(true);
  const [slotCorrectionResults, setSlotCorrectionResults] = useState(
    [] as SlotCorrectionResult[]
  );
  const [updatedSlotCorrectionResults, setUpdatedSlotCorrectionResults] =
    useState([] as SlotCorrectionResult[]);

  useEffect(() => {
    if (needFetchSlotCorrectionResult) {
      CalibrationApi.GetSlotCorrectionResult().then((slotCorrectionResults) => {
        setSlotCorrectionResults(slotCorrectionResults);
        setNeedFetchSlotCorrectionResult(false);
      });
    }
  }, [needFetchSlotCorrectionResult]);

  console.log(slotAddress);
  console.log(selectAllChecked);

  return (
    <div
      style={{
        width: "calc(100% - 16px)",
        border: "1px solid #B4B4B4",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <div className="slot-container">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <CommonDropDown<number>
              value={selectedSlot}
              id="slot-select"
              onChange={(value) => {
                setSelectedSlot(value);
                setSlotAddress([]);
                setSelectAllChecked([]);
              }}
              style={{
                width: 300,
                minHeight: 32,
                borderRadius: 4,
              }}
              dropDownDisplayValues={slotSelection}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "12px",
              }}
            >
              {selectedSlot === 2 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "5px",
                    textDecoration: "underline",
                  }}
                >
                  <button
                    className="btn-text"
                    onClick={() => onExpandAllToggleClicked()}
                    disabled={!canExpandAll}
                  >
                    Expand All
                  </button>
                  <button
                    className="btn-text"
                    disabled={canExpandAll}
                    onClick={() => onExpandAllToggleClicked()}
                  >
                    Collapse All
                  </button>
                </div>
              )}

              <MtiButton
                size="medium"
                style={{
                  padding: "6px 16px",
                }}
                onClick={() => runSlotCorrection()}
                disabled={
                  slotAddress.length === 0 ||
                  psrState?.state == EPsrState.Busy ||
                  slotCorrectionState?.isUpdatedSlotCorrectionExist
                }
              >
                RUN CORRECTION
              </MtiButton>
            </div>
          </div>
          <div
            className="small-container"
            style={{
              borderRadius: "8px",
              height: "270px",
              gap: "10px",
              overflow: "auto",
            }}
          >
            {selectedSlot === 1 && (
              <FailedSlotContent
                moduleIdentifier={storageModule.identifier}
                setSlotAddress={setSlotAddress}
                slotAddresses={slotAddress}
                slotCorrectionResults={slotCorrectionResults}
              />
            )}
            {selectedSlot === 2 && (
              <AllSlotContent
                selectAllChecked={selectAllChecked}
                setSelectAllChecked={setSelectAllChecked}
                setSlotAddress={setSlotAddress}
                slotAddress={slotAddress}
                moduleIdentifier={storageModule.identifier}
                accordionState={accordionState}
                setAccordionState={setAccordionState}
                slotCorrectionResults={slotCorrectionResults}
              />
            )}
            {selectedSlot === 3 && (
              <AllHotelContent
                setSlotAddress={setSlotAddress}
                slotAddress={slotAddress}
                moduleIdentifier={storageModule.identifier}
                slotCorrectionResults={slotCorrectionResults}
              />
            )}
          </div>

          {/*--------Correction Result--------*/}
          <CorrectionResultContent
            slotCorrectionResults={slotCorrectionResults}
            setSlotCorrectionResults={setSlotCorrectionResults}
            isSlotCorrectionUpdated={isSlotCorrectionUpdated}
            setIsSlotCorrectionUpdated={setIsSlotCorrectionUpdated}
            updatedSlotCorrectionResults={updatedSlotCorrectionResults}
            setUpdatedSlotCorrectionResults={setUpdatedSlotCorrectionResults}
            setNeedFetChSlotCorrectionResult={setNeedFetchSlotCorrectionResult}
          />
        </div>
      </div>
      <SlotCorrectionProgressModal
        show={popupModalState === "INPROGRESS"}
        onHide={() => {}}
        stopSlotCorrection={stopSlotCorrection}
        slotCorrectionState={
          slotCorrectionState?.modeState ?? ESuiteModeState.Starting
        }
      />
      <SlotCorrectionSuccessModal
        show={popupModalState === "SUCCESS"}
        onHide={onHideDone}
      />
      <SlotCorrectionPreconditionFailModal
        show={popupModalState === "FAIL"}
        onHide={onHideDone}
        disableAnimation={disableDoneAnimation}
      />
    </div>
  );
}
